import React from "react";
import PageLayout from "../PageLayout";

interface IProps {
  licenseId?: string;
}

const NoSuchLicense: React.FC<IProps> = ({ licenseId }) => (
  <PageLayout
    header="Oops"
    message={licenseId ? `${licenseId} is not a proper license id.` : "No license id provided"}
  />
);

export default NoSuchLicense;
